import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class BringozPieChartComponent implements IController {
  data: any;
  from: any;
  to: any;
  isStacked: any;
  showLegend: any;
  colors: any;

  public pieChart: any;
  public utilizedValue: any;

  defaultColors: any;
  format: any;

  constructor(private chartColors, private splitService) {
  }

  $onInit() {
    this.defaultColors = this.chartColors.defaultColors;
    this.format = this.splitService.getDateAndTimeConfig().long;

    this.pieChart = {
      type: 'PieChart',
      data: this.data,
      options: {
        // height: '150',
        // width: '150',
        pieHole: 0.6,
        pieSliceText: 'none',
        // pieSliceTextStyle: {
        //   color: 'black',
        //   // bold: true
        // },
        chartArea:{width:'100%',height:'70%', top: 5},
        legend: {
          position: 'bottom',
          labeledValueText: 'both'
        },
        height: 130,
        width: 200,

        colors: ['#6EAAF5', '#D5E3F5'],
        animation: {
          startup: true,
          duration: 1000,
          easing: "inAndOut"
        }
      },
    };

    this._setTextValues();
  }

  $onChanges(changes) {
    if (changes.data && !changes.data.isFirstChange()) {
      this.pieChart.data = this.getDataReadyForHebrew(this.data);
      this._setTextValues();
      if (this.from && this.to) {
        this.pieChart.options.vAxis.ticks = this.getTicks(this.data);
      }
    }
  }


  private getDataReadyForHebrew(data) {
    _.times(data.getNumberOfRows(), (index) => {
      var string = data.getValue(index, 0);
      if (_.isString(string)) {
        var position = string.search(/[\u0590-\u05FF]/);
        if (position >= 0) {
          data.setValue(index, 0, string.split('').reverse().join(''))
        }
      }
    });
    return data;
  }

  private getTicks(data) {
    let ticks = [];
    for (let i = 0; i < data.getNumberOfRows(); i++) {
      ticks.push(data.getValue(i, 0));
    }
    return ticks;
  }

  private _setTextValues() {
    const value = _.get(this.data, 'rows[0].c[1].v', 0);
    this.utilizedValue = `${(value && _.isNumber(value) ? Math.round(value) : 0)}%`;
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozPieChart', {
    bindings: {
      data: '<',
      from: '<',
      to: '<',
      isStacked: '<',
      showLegend: '<?',
      colors: '<?'
    },
    templateUrl: 'app/modules/commons/components/bringoz-pie-chart/bringoz-pie-chart.html',
    controller: BringozPieChartComponent
  });
